export function celsiusFahrenheit(temp) {
    return (temp * 9/5) + 32;
}
export function fahrenheitCelsius(temp) {
    return (temp -32) * 5/9;
}
export function formatTime(oldTime) {
  oldTime = oldTime.replace(":", " ");
  var arr = oldTime.split(" ");

  var ampm = arr[2].toLowerCase();
  var hour = 0;

  if (arr[0] == 12) {
    if (ampm == "am") {
      hour = 0;
    } else {
      hour = 12;
    }
  } else {
    if (ampm == "pm") {
      hour = parseInt(arr[0]) + 12;
    } else {
      hour = arr[0];
    }
  }
  return hour + ":" + arr[1];
}